import Vue from 'vue';
import Router from 'vue-router';

import Symptoms from '@/components/Symptoms'
import FAQ from '@/components/FAQ'
import Contact from '@/components/Contact'
import PrivacyPolicy from '@/components/Privacy Policy'

Vue.use(Router);

const router = new Router({
    linkExactActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            redirect: '/symptoms'
        },
        {
            path: '/symptoms',
            name: 'Symptoms',
            component: Symptoms
        },

        {
            path: '/faq',
            name: 'FAQ',
            component: FAQ
        },

        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },

        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        }

    ]
});


export default router;